module.exports = __webpack_public_path__ + "static/media/login_bg_4_1920x1080.8ab00e31.jpg";